<div class="dots-spinner__dot dots-spinner__dot-1"></div>
<div class="dots-spinner__dot dots-spinner__dot-2"></div>
<div class="dots-spinner__dot dots-spinner__dot-3"></div>
